
/**
 * Loading indicator component for content
 */
const ContentLoading = () => {
  // Check if we're on homepage
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '';
  
  // Don't show loading indicator on homepage
  if (isHomepage) {
    console.log("ContentLoading: On homepage, not showing loading indicator");
    return null;
  }
  
  return (
    <div className="flex items-center justify-center py-8">
      <div className="animate-pulse flex flex-col space-y-4 w-full">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
      </div>
    </div>
  );
};

export default ContentLoading;
